import React, { useContext, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProdutosContext } from 'contexts/ProdutosContext';
import { DropsContext } from 'contexts/DropsContext';
import VirtualDrop from 'components/VirtualDrop';
import Container from 'components/Container';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Header from 'components/Header';
import Button from 'components/Button';
import Loader from 'components/Loader';
import Input from 'components/Input';
import Card from 'components/Card';
import styles from './styles';
import moment from 'moment';

const Manutenção = () => {
  const defaultValues = {
    descricao_completa: '',
    descricao_reduzida: '',
    referencia: '',
    celinha_id: 9,
    servico_id: null,
    cfiscal_id: null,
    custo: '',
    preco: '',
    dtcad: moment().format('YYYY-MM-DD'),
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { drops } = useContext(DropsContext);
  const { postProduto, postLoading, produto, getLoading, getProduto } =
    useContext(ProdutosContext);
  const { control, handleSubmit, setValue } = useForm({ defaultValues });

  useEffect(() => {
    if (state?.id) {
      getProduto(state?.id);
    }
  }, []);

  useEffect(() => {
    if (produto && state?.id) {
      const descricao_completa = produto?.ProdutoDescricaos?.find(
        (d) => d?.tipo === 'COMPLETA'
      )?.descricao;
      const descricao_reduzida = produto?.ProdutoDescricaos?.find(
        (d) => d?.tipo === 'REDUZIDA'
      )?.descricao;
      setValue('descricao_completa', descricao_completa || '');
      setValue('descricao_reduzida', descricao_reduzida || '');
      setValue('referencia', produto?.referencia || '');
      setValue('celinha_id', produto?.celinha_id || null);
      setValue('servico_id', produto?.servico_id || null);
      setValue('cfiscal_id', produto?.cfiscal_id || null);
      setValue('custo', produto?.custo_compra || '');
      setValue('preco', produto?.preco || '');
      setValue('dtcad', produto?.dtcad || moment().format('YYYY-MM-DD'));
    }
  }, [produto]);

  const onPost = ({
    descricao_completa,
    descricao_reduzida,
    preco,
    custo,
    ...Produto
  }) => {
    const Descricoes = [];
    let Preco = {};
    let Custo = {};
    if (preco) {
      Preco = { ...Preco, preco };
    }
    if (custo) {
      Custo = { ...Custo, custo };
    }
    if (Boolean(descricao_completa)) {
      Descricoes?.push({
        tipo: 'COMPLETA',
        descricao: descricao_completa,
      });
    }
    if (Boolean(descricao_reduzida)) {
      Descricoes?.push({
        tipo: 'REDUZIDA',
        descricao: descricao_reduzida,
      });
    }
    let data = { Produto };
    if (Boolean(Descricoes?.length)) {
      data = { ...data, Descricoes };
    }
    if (Boolean(Object.keys(Preco)?.length)) {
      data = { ...data, Preco };
    }
    if (Boolean(Object.keys(Custo)?.length)) {
      data = { ...data, Custo };
    }
    return data;
  };

  const onPut = ({
    descricao_completa,
    descricao_reduzida,
    preco,
    custo,
    ...rest
  }) => {
    const Descricoes = [];
    const Produto = { id: state?.id, ...rest };
    let Preco = {};
    let Custo = {};
    if (preco !== produto?.preco) {
      Preco = { ...Preco, preco: preco || 0 };
    }
    if (custo && custo !== produto?.custo_compra) {
      Custo = { ...Custo, custo };
    }
    if (Boolean(produto) || Boolean(descricao_completa)) {
      const desc = produto?.ProdutoDescricaos?.find(
        (d) => d?.tipo === 'COMPLETA'
      );
      Descricoes?.push({
        id: desc?.id,
        produto_id: state?.id,
        tipo: 'COMPLETA',
        descricao: descricao_completa,
      });
    }
    if (Boolean(produto) || Boolean(descricao_reduzida)) {
      const desc = produto?.ProdutoDescricaos?.find(
        (d) => d?.tipo === 'REDUZIDA'
      );
      Descricoes?.push({
        id: desc?.id,
        produto_id: state?.id,
        tipo: 'REDUZIDA',
        descricao: descricao_reduzida,
      });
    }
    let data = { Produto };
    if (Boolean(Descricoes?.length)) {
      data = { ...data, Descricoes };
    }
    if (Boolean(Object.keys(Preco)?.length)) {
      data = { ...data, Preco };
    }
    if (Boolean(Object.keys(Custo)?.length)) {
      data = { ...data, Custo };
    }
    return data;
  };

  const onSubmit = (values) => {
    const data = state?.id ? onPut(values) : onPost(values);
    postProduto({ data, cb: () => navigate(-1) });
  };

  if (getLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <Header
        titulo={(Boolean(state?.id) ? 'Editar' : 'Cadastrar') + ' Serviço'}
      />
      <Card title="Informações Gerais">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Input
              name="descricao_completa"
              control={control}
              label="Descrição Completa"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input
              name="descricao_reduzida"
              control={control}
              label="Descrição Reduzida"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="servico_id"
              control={control}
              label="Serviço"
              options={drops?.Servico}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <VirtualDrop
              name="cfiscal_id"
              control={control}
              label="Classificação Fiscal"
              options={drops?.Cfiscal}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Input name="referencia" control={control} label="Referência" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask name="custo" control={control} label="Custo" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask name="preco" control={control} label="Preço de Venda" />
          </Grid>
        </Grid>
      </Card>
      <Grid item xs={12} textAlign="center" sx={styles?.button}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(onSubmit)}
          loading={postLoading}
        >
          Salvar
        </Button>
      </Grid>
    </Container>
  );
};

export default Manutenção;
